/**
 * Optional overrides for setting the API endpoint
 */
interface Options {
  /** The subdomain to use, i.e. 'demo', 'beta' or 'www'. */
  subdomain?: string

  /** The version of the API to use */
  version?: string
}

/**
 * Constructs the default API endpoint for all sharing stuff
 * @param domainName -  - The domain name of the tenant, i.e. `tagesanzeiger` or `derbund`. Without the top-level domain!
 * @param opts
 */
export const defaultSharingEndpoint = (
  domainName: string,
  opts: Options = {}
) => {
  const { subdomain = 'www', version = 'v1' } = opts
  return `https://${subdomain}.${domainName}.ch/disco-api/${version}/sharing`
}

/**
 * Constructs the API endpoint for the sharing counts.
 * @param domainName - The domain name of the tenant, i.e. `tagesanzeiger` or `derbund`. Without the top-level domain!
 * @param articleId - The article ID
 * @param opts {Options}
 */
export const countsEndpoint = (
  domainName: string,
  articleId: string | number,
  opts?: Options
) => `${defaultSharingEndpoint(domainName, opts)}/${articleId}`

/**
 * Construct the API endpoint for sending back share signals to the Sharing API
 * @param domainName - The domain name of the tenant, i.e. `tagesanzeiger` or `derbund`. Without the top-level domain!
 * @param opts {Options}
 */
export const shareSignalEndpoint = (domainName: string, opts?: Options) =>
  `${defaultSharingEndpoint(domainName, opts)}`
